// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  appName:"مكتبة اوراق",

  // source:'http://108.181.192.149:4013/',
  // baseURL:'http://108.181.192.149:4013/api',

  source:'https://paper-library.md-soft.app/',
  baseURL:'https://paper-library.md-soft.app/api',

  // baseURL:'http://localhost:4001/api',
  // source:'http://localhost:4001/',


  bundleId:"iraqsoft.paperlibrary.app",
  firebaseTopic:'-paper-library'


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
